export default "__VITE_ASSET__3ejLd3$c__"